import mitt from 'mitt';

// basic mitt instance
const emitter = mitt()
export default emitter;

// Events listing
export const EVENTS = {
  // UiKit - Cursor
  CURSOR_UPDATE: 'cursor-update', // reset window events listener mouseover binding

  // UiKit - Videos
  VIDEO_STOP_ALL: 'video-stop-all', // force stop every video

  // UiKit - Lightbox
  LIGHTBOX_CLOSE_ALL: 'lightbox-close-all', // force close every lightbox

  // WebGLSpritesheet TextureLoaded
  SPRITESHEET_FRAME_LOADED: 'webglspritesheet-frame-loaded', // a frame is loaded 
  SPRITESHEET_READY: 'webglspritesheet-ready', // everything is loaded 
  SPRITESHEET_FRAME_EVENT: 'webglspritesheet-frame-event', // an event on a frame 
  SPRITESHEET_LAST_FRAME: 'webglspritesheet-last-frame', // an event on the last frame 

  SHOW_LISTING: 'show-listing', // show the listing
  HIDE_SPRITESHEET: 'hide-spritesheet', // hide and dispose the intro spritesheet (with the webgl scene)

  THEME_SWITCHING: 'switch-theme-start',
  CLICK_THEME: 'click-theme',
  CLICK_OBJECT: 'click-object',
  PAGE_TRANSITION: 'page-transition',

  OBJECT_DETAIL_READY: 'object-detail-ready',
  OBJECT_SHOW_ARTICLE: 'object-show-article',
  
  STOP_INACTIVE: 'stop-inactive',
  RESET_INACTIVE: 'reset-inactive',
};
